import './mobile-tabs'
import './accordions'
import {initSearchFilter} from './blog-search-filter'

initSearchFilter()

const userBurger = document.querySelector('.js-user-burger')
const userClose = document.querySelector('.js-user-close')

if (userBurger) {
  userBurger.onclick = () => {
    document.querySelector('.user-menu__mobile').classList.toggle('active')
  }
}

if (userClose) {
  userClose.onclick = () => {
    document.querySelector('.user-menu__mobile').classList.toggle('active')
  }
}

const ordersAcceptIcon = document.querySelector('.js-user-my-order__accept-picture-icon')
if (ordersAcceptIcon) {
  ordersAcceptIcon.onclick = () => {
    document.querySelector('.user-my-order__accept').classList.toggle('active')
    document.querySelector('.js-user-my-order__accept-full-wrapper').classList.toggle('active')
    ordersAcceptIcon.classList.toggle('rotate')
  }
}
const ordersDeliveryIcon = document.querySelector('.js-user-my-order__delivered-picture-icon')
if (ordersDeliveryIcon) {
  ordersDeliveryIcon.onclick = () => {
    ordersDeliveryIcon.classList.toggle('rotate')
  }
}

const ordersMobileIcon = document.querySelector('.js-user-my-order__status-mobile-icon')
if (ordersMobileIcon) {
  ordersMobileIcon.onclick = () => {
    ordersMobileIcon.classList.toggle('rotate')
    document.querySelector('.js-user-my-order__status').classList.toggle('active')
  }
}

const userSupportElements = document.querySelector('.js-user-support')
if (userSupportElements) {
  userSupportElements.querySelectorAll('.js-user-support__icon').forEach(e => e.addEventListener('click', () => {
    e.classList.toggle('rotate')
    e.parentNode.classList.toggle('active')
  }))
}



